import React, { useEffect, useRef } from 'react';

import Icons from 'components/atoms/Icons';
import {
  AddFilterType,
  FilterPanelType,
  LocationFilterOptionsType,
  LocationFilterPanelsType,
  LocationFiltersType,
  OnQueryInputChangeType,
  RemoveFilterType,
  ReplaceLocationFiltersType,
  SetActiveFilterPanelType,
  SetControlPanelType,
  UpdateFilterType,
  UpdateQueryType,
} from 'components/types/FilterTypes';
import {
  BuildAddress,
  SetLatLng,
} from 'components/types/LocationFunctionTypes';
import StandardFilter from 'components/pld/shared/filters/StandardFilter';
import FilterAccordionBtn from 'components/pld/providers/filters/FilterAccordionBtn';

type LocationFiltersProps = {
  active: boolean;
  activeFilterPanel: string;
  addFilter: AddFilterType;
  buildAddress: BuildAddress;
  clearAllFilters: () => void;
  filters: LocationFilterOptionsType;
  filterDefaults: {};
  filterPanels: Array<FilterPanelType>;
  geolocate: () => void;
  geolocating: boolean;
  loading: boolean;
  query: string;
  queryInputValue: string;
  onQueryInputChange: OnQueryInputChangeType;
  count: number;
  selectedFacets: any;
  selectedFacetsCount: number;
  removeFilter: RemoveFilterType;
  removeLocationFilters: () => void;
  replaceFilter: (filter: string, arr: Array<string>) => void;
  replaceLocationFilters: ReplaceLocationFiltersType;
  searchType: string;
  selectedFilters: LocationFiltersType;
  setActiveFilterPanel: SetActiveFilterPanelType;
  setControlPanel: SetControlPanelType;
  setLatLng: SetLatLng;
  updateFilter: UpdateFilterType;
  updateQuery: UpdateQueryType;
  closeMobileControls: () => void;
  desktopControlsOpen: boolean;
  closeDesktopControls: () => void;
  resultsCount?: number;
};
const LocationFilters = (props: LocationFiltersProps) => {
  const { locationtypes } = props.filters;

  const {
    activeFilterPanel,
    addFilter,
    clearAllFilters,
    filters,
    filterPanels,
    selectedFacetsCount,
    removeFilter,
    selectedFilters,
    setActiveFilterPanel,
    closeMobileControls,
    closeDesktopControls,
    resultsCount,
  } = props;

  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      const target = e.target as HTMLElement;

      const clickedInsideLocationFilter =
        target.closest('.location-panel') ||
        target.closest('.location-search-input') ||
        target.closest('.react-autosuggest__suggestions-container') ||
        target.closest('.typeahead-suggestion');

      if (clickedInsideLocationFilter) {
        return;
      }

      if (sidebarRef.current && !sidebarRef.current.contains(target)) {
        closeDesktopControls();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [closeDesktopControls]);

  return (
    <div className="filter-bar-wrapper">
      <h2 className="screen-recording-only only-desktop" tabIndex={0}>
        Filters
      </h2>
      <div className="filter-bar" ref={sidebarRef}>
        <div className="filter-title-bar">
          <div
            className="close-button only-mobile"
            onClick={() => closeMobileControls()}
          >
            <Icons id="close" className="icon icon-close" aria-hidden="true" />
          </div>
          <h3 className="filters-title only-mobile">Filters</h3>
        </div>
        <div className="filters">
          {filterPanels.map((filterPanel: FilterPanelType) => {
            if (
              filterPanel.id === 'search' ||
              filterPanel.id === 'location' ||
              filterPanel.id === 'preferredProvider'
            ) {
              return null;
            }

            const menuHeight = filterPanel.active
              ? { maxHeight: '2000px' }
              : {};

            return (
              <div key={filterPanel.id}>
                <FilterAccordionBtn
                  setActiveFilterPanel={setActiveFilterPanel}
                  filterPanel={filterPanel}
                  activeFilterPanel={activeFilterPanel}
                  selectedFilters={selectedFilters}
                  filters={filters}
                ></FilterAccordionBtn>
                <div>
                  {filters[filterPanel.id as LocationFilterPanelsType]
                    ?.length ? (
                    <div className="expanded-filters" style={menuHeight}>
                      <>
                        {filterPanel.id === 'locationtypes' &&
                          filterPanel.active && (
                            <StandardFilter
                              addFilter={addFilter}
                              filters={locationtypes}
                              filterCategory="locationtypes"
                              placeholder="Enter location type"
                              removeFilter={removeFilter}
                              selectedData={selectedFilters.locationtypes}
                              title="Location Type"
                            />
                          )}
                      </>
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
        <div className="bg-primary btns-container">
          {selectedFacetsCount ? (
            <button
              className="btn-secondary no-icon only-mobile"
              onClick={() => {
                clearAllFilters();
              }}
              aria-label={`Clear All Filters`}
            >
              Clear All
            </button>
          ) : null}
          <button
            className="view-all-btn btn-primary no-icon btn-fw only-mobile"
            onClick={() => closeMobileControls()}
          >
            Show {resultsCount} Results
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationFilters;
